// assets
import DashboardIcon from '@mui/icons-material/Dashboard'; // Replaces DashboardOutlined
import AssignmentIcon from '@mui/icons-material/Assignment'; // Replaces AssignmentIcon
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'; // Replaces AccountBalanceIcon
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'; // Replaces ChatBubbleOutlineIcon
import InventoryIcon from '@mui/icons-material/Inventory'; // Replaces InventoryIcon (or CategoryIcon)
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'; // Replaces ReceiptLongIcon
import StorefrontIcon from '@mui/icons-material/Storefront'; // Replaces StorefrontIcon
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt'; // Replaces PersonAddAltIcon
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'; // Replaces PersonOutlineIcon
import GroupsIcon from '@mui/icons-material/Groups'; // Replaces GroupsIcon
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';// Replaces AccountBalanceWalletOutlinedIcon
import TaskAltIcon from '@mui/icons-material/TaskAlt'; // Replaces TaskAltIcon
import SettingsIcon from '@mui/icons-material/Settings'; // Replaces SettingsIcon
import BadgeIcon from '@mui/icons-material/Badge'; // Replaces BadgeIcon
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; // Replaces AssignmentIndIcon

import TripOriginIcon from '@mui/icons-material/TripOrigin';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import RouteIcon from '@mui/icons-material/Route';
import ApiIcon from '@mui/icons-material/Api';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { styled } from '@mui/material';

const RotatedRouteIcon = styled(RouteIcon)({
  transform: 'rotate(90deg)'
});

// icons
const icons = {
  DashboardIcon,
  AccountBalanceIcon,
  PersonOutlineIcon,
  ReceiptLongIcon,
  ChatBubbleOutlineIcon,
  StorefrontIcon,
  PersonAddAltIcon,
  InventoryIcon,
  AssignmentIcon,
  GroupsIcon,
  AccountBalanceWalletOutlinedIcon,
  TaskAltIcon,
  SettingsIcon,
  BadgeIcon,
  AssignmentIndIcon,
  TripOriginIcon,
  CreditCardIcon,
  RouteIcon: RotatedRouteIcon,
  ApiIcon,
  UploadFileIcon
};


// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages = {
  id: 'group-pages',
  title: 'pages',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: icons.DashboardIcon,
      type: 'item',
      url: '/dashboard',
      role: 'ALL',
      onlyForUsers: ['STRICT_ACCESS_ONLY']
    },

    {
      id: 'master',
      title: 'Master',
      icon: icons.GroupsIcon,
      type: 'collapse',
      role: ['ROLE_ADMIN'],
      children: [
        {
          id: 'department',
          title: 'Department',
          // icon: 'badge',
          type: 'item',
          url: '/view-department',
          role: ['ROLE_ADMIN'],
          subRoutes: [
            {
              url: '/create-department',
              title: 'Create',
            },
            {
              url: '/map-department',
              title: 'Map',
            },
          ]
        },
        {
          id: 'designation',
          title: 'Designation',
          // icon: 'assignment_ind',
          type: 'item',
          url: '/view-designation',
          role: ['ROLE_ADMIN'],
          subRoutes: [
            {
              url: '/create-designation',
              title: 'Create',
            },
          ]
        },
        {
          id: 'branch',
          title: 'Branch',
          // icon: 'manage_accounts',
          type: 'item',
          url: '/view-branch',
          role: ['ROLE_ADMIN'],
          subRoutes: [
            {
              url: '/create-branch',
              title: 'Create',
            },
          ]
        },
        {
          id: 'role',
          title: 'Role',
          // icon: 'admin_panel_settings',
          type: 'item',
          url: '/view-role',
          role: ['ROLE_ADMIN'],
          subRoutes: [
            {
              url: '/create-role',
              title: 'Create',
            },
            {
              url: '/map-role',
              title: 'Map',
            },
          ]
        },
      ]
    },
    {
      id: 'bank-user',
      title: 'Bank User',
      icon: icons.AssignmentIndIcon,
      type: 'collapse',
      role: ['ROLE_ADMIN'],
      children: [
        {
          id: 'create-bank-user',
          title: 'Create',
          // icon: 'person_add',
          type: 'item',
          url: '/create-bank-user',
          role: ['ROLE_ADMIN']
        },
        {
          id: 'view-bank-user',
          title: 'View',
          // icon: 'visibility',
          type: 'item',
          url: '/view-bank-user',
          role: ['ROLE_ADMIN']
        },
        {
          id: 'draft-bank-user',
          title: 'Drafted Request',
          // icon: 'streetview',
          type: 'item',
          url: '/draft-bank-user',
          role: ['ROLE_ADMIN']
        }
      ]
    },
    {
      id: 'prog-manager',
      title: 'Prog. Manager',
      icon: icons.AssignmentIcon,
      type: 'collapse',
      role: ['ROLE_MASTER_DISTRIBUTOR'],
      children: [
        {
          id: 'create-pm',
          title: 'Create',
          // icon: 'person_add',
          type: 'item',
          url: '/create-pm',
          role: ['ROLE_MASTER_DISTRIBUTOR']
        },
        {
          id: 'view-pm',
          title: 'View',
          // icon: 'preview',
          type: 'item',
          url: '/view-pm',
          role: ['ROLE_MASTER_DISTRIBUTOR']
        },
        {
          id: 'draft-pm',
          title: 'Drafted Request',
          // icon: 'streetview',
          type: 'item',
          url: '/draft-pm',
          role: ['ROLE_MASTER_DISTRIBUTOR']
        }
      ]
    },
    {
      id: 'prog-manager-admin',
      title: 'Prog. Manager Admin',
      icon: icons.BadgeIcon,
      type: 'collapse',
      role: [],
      privilege: ['7', '72', '71'],
      children: [
        {
          id: 'create-pm-admin',
          title: 'Create',
          // icon: 'person_add',
          type: 'item',
          url: '/create-pm-admin',
          role: [],
          privilege: ['7']
        },
        {
          id: 'view-pm-admin',
          title: 'View',
          // icon: 'preview',
          type: 'item',
          url: '/view-pm-admin',
          role: [],
          privilege: ['7', '71']
        },
        {
          id: 'draft-pm-admin',
          title: 'Drafted Request',
          // icon: 'streetview',
          type: 'item',
          url: '/draft-pm-admin',
          role: [],
          privilege: ['7']
        },
        {
          id: 'pm-admin-request',
          title: 'Pending Request',
          // icon: 'pending',
          type: 'item',
          url: '/pm-admin-request',
          role: [],
          privilege: ['72']
        },
        {
          id: 'pm-admin-change-request',
          title: 'Change Request',
          // icon: 'pending',
          type: 'item',
          url: '/pm-admin-change-request',
          role: [],
          privilege: ['72']
        }
      ]
    },
    {
      id: 'corporate-admin',
      title: 'Corporate Admin',
      icon: icons.PersonAddAltIcon,
      type: 'collapse',
      role: [],
      privilege: ['9', '91', '92'],
      children: [
        {
          id: 'create-corp-admin',
          title: 'Create',
          // icon: 'person_add',
          type: 'item',
          url: '/create-corp-admin',
          role: [],
          privilege: ['9']
        },
        {
          id: 'view-corp-admin',
          title: 'View',
          // icon: 'preview',
          type: 'item',
          url: '/view-corp-admin',
          role: [],
          privilege: ['9', '91']
        },
        {
          id: 'draft-corp-admin',
          title: 'Drafted Request',
          // icon: 'edit_note',
          type: 'item',
          url: '/draft-corp-admin',
          role: [],
          privilege: ['9']
        },
        {
          id: 'corp-admin-request',
          title: 'Pending Request',
          // icon: 'visibility',
          type: 'item',
          url: '/corp-admin-request',
          role: [],
          privilege: ['92']
        },
        {
          id: 'corp-admin-change-request',
          title: 'Change Request',
          // icon: 'visibility',
          type: 'item',
          url: '/corp-admin-change-request',
          role: [],
          privilege: ['9', '92']
        }
      ]
    },
    {
      id: 'corporate',
      title: 'Corporate',
      icon: icons.PersonAddAltIcon,
      type: 'collapse',
      role: ['ROLE_DISTRIBUTOR'],
      children: [
        {
          id: 'create-corp',
          title: 'Create',
          // icon: 'person_add',
          type: 'item',
          url: '/create-corp',
          role: ['ROLE_DISTRIBUTOR']
        },
        {
          id: 'view-corp',
          title: 'View',
          // icon: 'preview',
          type: 'item',
          url: '/view-corp',
          role: ['ROLE_DISTRIBUTOR']
        },
        {
          id: 'draft-corp',
          title: 'Drafted Request',
          // icon: 'edit_note',
          type: 'item',
          url: '/draft-corp',
          role: ['ROLE_DISTRIBUTOR']
        }
      ]
    },
    {
      id: 'product',
      title: 'Product',
      icon: icons.InventoryIcon,
      type: 'collapse',
      role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR'],
      children: [
        {
          id: 'create-product',
          title: 'Create',
          // icon: 'add_card',
          type: 'item',
          url: '/create-product',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
        },
        {
          id: 'view-product',
          title: 'View',
          // icon: 'visibility',
          type: 'item',
          url: '/view-product',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
        },
        {
          id: 'pending-product',
          title: 'Pending Request',
          // icon: 'rule',
          type: 'item',
          url: '/product/pending-product',
          role: ['ROLE_ADMIN']
        },
        {
          id: 'change-product',
          title: 'Change Request',
          // icon: 'rule',
          type: 'item',
          url: '/product/change-request',
          role: ['ROLE_ADMIN']
        },
        {
          id: 'draft-product',
          title: 'Drafted Request',
          // icon: 'edit_note',
          type: 'item',
          url: '/draft-product',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
        },
      ]
    },
    {
      id: 'inventory',
      title: 'Inventory',
      icon: icons.StorefrontIcon,
      type: 'collapse',
      role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_SUPER_ADMIN'],
      privilege: ['16'],
      children: [

        {
          id: 'buy-cards',
          title: 'Buy Card',
          // icon: 'local_mall',
          type: 'item',
          url: '/buy-cards',
          role: ['ROLE_MASTER_DISTRIBUTOR'],
          privilege: ['16'],
          subRoutes: [
            {
              url: '/my-orders',
              title: 'My Orders',
              subRoutes: [
                {
                  url: '/card-shipping',
                  title: 'Card Shipping',
                },
              ]
            },
          ]
        },
        {
          id: 'shipping-report',
          title: 'Shipping Report',
          // icon: 'local_shipping',
          type: 'item',
          url: '/shipping-report',
          role: ['ROLE_MASTER_DISTRIBUTOR', 'ROLE_ADMIN'],
          privilege: ['16'],
          subRoutes: [
            {
              url: '/nonperso-perso-report',
              title: 'Non-Perso Shipped Cards',
            },
            {
              url: '/transfer-card-details',
              title: 'Transfer CardsDetails',
            },
            {
              url: '/transfer-card',
              title: 'Transfer Card',
            },
          ],
        },
        {
          id: 'card-request',
          title: 'Card Request',
          // icon: 'dynamic_feed',
          type: 'collapse',
          role: ['ROLE_MASTER_DISTRIBUTOR'],
          children: [
            {
              id: 'card-request-pending',
              title: 'Pending Requests',
              // icon: 'rule',
              type: 'item',
              url: '/card-request/request',
              role: ['ROLE_MASTER_DISTRIBUTOR']
            },
            {
              id: 'card-request-report',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/card-request/report',
              role: ['ROLE_MASTER_DISTRIBUTOR']
            }
          ]
        },
        {
          id: 'view-stock',
          title: 'Stock Report',
          // icon: 'inventory',
          type: 'item',
          url: '/view-stock',
          role: ['ROLE_SUPER_ADMIN']
        },
        {
          id: 'branch-report',
          title: 'Branch Report',
          // icon: 'summarize',
          type: 'item',
          url: '/branch-report',
          role: ['ROLE_ADMIN']
        },
        {
          id: 'virtual-to-physical',
          title: 'Virtual to Physical Request',
          // icon: 'dynamic_feed',
          type: 'collapse',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR'],
          children: [
            {
              id: 'virtual-to-physical-request',
              title: 'Pending Requests',
              // icon: 'rule',
              type: 'item',
              url: '/virtual-to-physical/request',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR']
            },
            {
              id: 'virtual-to-physical-report',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/virtual-to-physical/report',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR']
            }
          ]
        },
        {
          id: 'inventory-PM-admin',
          title: 'PM Admin',
          // icon: 'category',
          type: 'collapse',
          role: ['ROLE_ADMIN'],
          children: [
            {
              id: 'inventory-pm-admin-request',
              title: 'Pending Request',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/pm-admin-request',
              role: ['ROLE_ADMIN']
            },
            {
              id: 'inventory-pm-admin-view',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/pm-admin-view',
              role: ['ROLE_ADMIN']
            }
          ]
        },
        {
          id: 'inventory-corp-admin',
          title: 'Corp. Admin',
          // icon: 'category',
          type: 'collapse',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR'],
          children: [
            {
              id: 'inventory-corp-admin-request',
              title: 'Pending Request',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/corp-admin-request',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
            },
            {
              id: 'inventory-corp-admin-view',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/corp-admin-view',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
            }
          ]
        },
        {
          id: 'inventory-program-manager',
          title: 'Program Manager',
          // icon: 'category',
          type: 'collapse',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR'],
          children: [
            {
              id: 'inventory-pm-request',
              title: 'Pending Request',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/pm-request',
              role: ['ROLE_ADMIN']
            },
            {
              id: 'inventory-pm-view',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/pm-view',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
            }
          ]
        },
        {
          id: 'inventory-corporate',
          title: 'Corporate',
          // icon: 'category',
          type: 'collapse',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR'],
          children: [
            {
              id: 'inventory-corp-request',
              title: 'Pending Request',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/corp-request',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
            },
            {
              id: 'inventory-corp-view',
              title: 'View',
              // icon: 'rule',
              type: 'item',
              url: '/inventory/corp-view',
              role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR']
            }
          ]
        }
      ]
    },
    {
      id: 'customer',
      title: 'Customer',
      icon: icons.PersonOutlineIcon,
      type: 'collapse',
      role: [],
      privilege: ['13', '17', '171'],
      children: [
        {
          id: 'create-customer',
          title: 'Create',
          // icon: 'group_add',
          type: 'item',
          url: '/create-customer',
          role: [],
          privilege: ['13'],
          subRoutes: [
            {
              url: '/bulk-customer',
              title: 'Bulk Customer',
              subRoutes: [
                {
                  url: '/bulk-customer-report',
                  title: 'Report'
                },
              ]
            }
          ]
        },
        {
          id: 'draft-customer',
          title: 'Drafted Request',
          // icon: 'edit_note',
          type: 'item',
          url: '/draft-customer',
          role: [],
          privilege: ['13']
        },
        {
          id: 'all-cards',
          title: 'Cards',
          // icon: 'credit_card_gear',
          type: 'item',
          url: '/all-cards',
          role: [],
          privilege: ['17'],
          subRoutes: [
            {
              url: '/bulk-load',
              title: 'Bulk Load',
              subRoutes: [
                {
                  url: '/bulk-load-report',
                  title: 'Report'
                },
              ]
            },
            {
              url: '/bulk-pin-set',
              title: 'Bulk Pin Set',
              subRoutes: [
                {
                  url: '/bulk-pin-set-report',
                  title: 'Report'
                },
              ]
            },
            {
              id: 'card-details',
              title: 'Card Details',
              // icon: 'credit_card_gear',
              type: 'item',
              url: '/card-details',
              role: []
            }
          ]
        }
      ]
    },
    {
      id: 'pay-user',
      title: 'Pay User',
      icon: icons.AccountBalanceIcon,
      type: 'item',
      url: '/pay-user',
      role: [],
      privilege: ['200', '210']
    },
    {
      id: 'load-wallet',
      title: 'Load Wallet',
      icon: icons.AccountBalanceIcon,
      type: 'item',
      url: '/manage-wallet/load-wallet',
      role: [],
      privilege: ['19']
    },
    // {
    //   id: 'commission-setting',
    //   title: 'Commission Setting',
    //   icon: icons.SettingsIcon,
    //   type: 'item',
    //   url: 'https: //commission-new-be2b8.web.app?authToken=',
    //   external: true,
    //   target: true,
    //   tokenAuth: true,
    //   role: ['ROLE_ADMIN']
    // },
    {
      id: 'view-bin',
      title: 'BIN Settings',
      icon: icons.TaskAltIcon,
      type: 'item',
      url: '/view-bin',
      role: ['ROLE_SUPER_ADMIN'],
      subRoutes: [
        {
          url: '/create-bin',
          title: 'Create',
        },
      ]
    },
    {
      id: 'assign-bin',
      title: 'BIN Settings',
      icon: icons.TaskAltIcon,
      type: 'item',
      url: '/view-assign-bin',
      role: ['ROLE_ADMIN'],
      subRoutes: [
        {
          url: '/assign-bin',
          title: 'Assign',
        },
      ]
    },
    {
      id: 'wallet',
      title: 'Wallet',
      icon: icons.AccountBalanceWalletOutlinedIcon,
      type: 'collapse',
      role: [],
      privilege: ['220'],
      children: [
        {
          id: 'add-balance',
          title: 'Add Balance',
          icon: 'account_balance_wallet',
          type: 'item',
          url: '/add-balance',
          role: [],
          privilege: ['220']
        },
        {
          id: 'wallet-report',
          title: 'Wallet Report',
          icon: 'description',
          type: 'item',
          url: '/wallet-report',
          role: [],
          privilege: ['220']
        }
      ]
    },
    {
      id: 'report-center',
      title: 'Report Center',
      icon: icons.ReceiptLongIcon,
      type: 'collapse',
      role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR', 'FINANCE'],
      onlyForUsers: ['STRICT_ACCESS_ONLY'],
      children: [
        {
          id: 'onboarding-report',
          title: 'Customer Onboarding Report',
          icon: '',
          type: 'item',
          url: '/reports/onboarding-report',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR'],
          onlyForUsers: ['STRICT_ACCESS_ONLY']
        },
        {
          id: 'admin-report',
          title: 'Other Reports',
          icon: '',
          type: 'item',
          url: '/reports/admin-report',
          role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR', 'FINANCE'],
          onlyForUsers: ['STRICT_ACCESS_ONLY']
        },
      ]
    },
    {
      id: 'all-tickets',
      title: 'Customer Support',
      icon: icons.ChatBubbleOutlineIcon,
      type: 'item',
      url: '/all-tickets',
      role: ['ROLE_ADMIN', 'ROLE_MASTER_DISTRIBUTOR', 'ROLE_DISTRIBUTOR'],
      subRoutes: [
        {
          url: '/raise-query',
          title: 'Raise Query',
        },
        {
          url: '/ticket-details',
          title: 'View Query',
        },
      ]
    },
    {
      id: 'view-wallet-limits',
      title: 'Wallet Settings',
      icon: icons.AccountBalanceWalletOutlinedIcon,
      type: 'item',
      url: '/wallet-setting',
      role: ['ROLE_SUPER_ADMIN'],
      subRoutes: [
        {
          url: '/view-wallet-limits',
          title: 'View Wallet Limits',
        }
      ]
    },
    {
      id: 'card-template',
      title: 'Card Template',
      icon: icons.CreditCardIcon,
      type: 'item',
      url: '/card-template/view-tepmlate',
      role: ['ROLE_SUPER_ADMIN']
    },
    {
      id: 'origin-manage',
      title: 'Origin',
      icon: icons.TripOriginIcon,
      type: 'item',
      url: '/origin-manage',
      role: ['ROLE_SUPER_ADMIN']
    },
    {
      id: 'feature-mapping',
      title: 'Feature Mapping',
      icon: icons.RouteIcon,
      type: 'item',
      url: '/feature-mapping',
      role: ['ROLE_SUPER_ADMIN']
    },
    {
      id: 'api-partner',
      title: 'API Partner',
      icon: icons.ApiIcon,
      type: 'item',
      url: '/api-partner',
      role: ['ROLE_SUPER_ADMIN']
    },
    {
      id: 'embossa',
      title: 'Embossa',
      icon: icons.UploadFileIcon,
      type: 'item',
      url: '/add-embossa',
      role: ['ROLE_SUPER_ADMIN'],
      subRoutes: [
        {
          url: '/embossa-report',
          title: 'View Report',
        }
      ]
    }
  ]
};

export default pages;
